import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode
}

const Leave: React.FC<Props> = ({
    children
}) => {
    return (
        <div className='vodPop'>{children}</div>
    )
}

export default Leave;